export default __webpack_public_path__ + "static/media/settings.d68ab746.png";